var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_vm._l((_vm.teacher.getSteps()),function(step,stepIdx){return [_vm._l((step.points),function(point,pointIdx){return [_c('div',{key:`${stepIdx}_${pointIdx}`,staticClass:"desc-container",staticStyle:{"display":"none"},attrs:{"data-stepIdx":step.stepIdx}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(point.title))])])]})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }